import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as LayerActions from '~app/actions/layers';

class DiscreteTimeline extends Component {
  static propTypes = {
    maps: PropTypes.array,
  }

  renderDiscreteTimelineButton(mapDef, index) {
    return (
      <button
        key={mapDef.name}
        className={classNames("DiscreteTimeline__button", {
          "DiscreteTimeline__button--highlighted": index === this.props.activeMapIndex,
        })}
        onClick={() => this.props.setMapIndex(index)}
      >
        {mapDef.displayName}
      </button>
    );
  }

  render() {
    return (
      <div className="DiscreteTimeline">
        {this.props.maps.map(::this.renderDiscreteTimelineButton)}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  maps: state.layer.layers[state.layer.activeLayerIndex].maps,
  activeMapIndex: state.layer.activeMapIndex,
});

const mapDispatchToProps = {
  setMapIndex: LayerActions.setMapIndex,
};

export { DiscreteTimeline };
export default connect(mapStateToProps, mapDispatchToProps)(DiscreteTimeline);



// WEBPACK FOOTER //
// ./src/components/DiscreteTimeline.js